import { observer } from 'mobx-react-lite'

import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../common'

import ConnectImage from './ConnectImage'

const ConnectMiniWidgetCard = () => {
  const { connect: connectCopy } = useGlobalCopyStore()

  return (
    <Stack alignItems="center" direction="column" m={24}>
      <ConnectImage />
      <Text
        sx={{
          mt: 16,
          textAlign: 'center',
        }}
        variant="subtitle1"
      >
        {connectCopy.mini_widget_content}
      </Text>
    </Stack>
  )
}

export default observer(ConnectMiniWidgetCard)
